export default {
  name: 'icon-info-svg'
};